import Dropzone from 'dropzone'
window.Dropzone = Dropzone
Dropzone.autoDiscover = false

window.dropzone_config = function (random_id) {
  var myDropzone = new Dropzone('#rf-' + random_id, {
    url: document.querySelector('#rf-' + random_id).action,
    paramName: 'referrer_file',
    autoProcessQueue: false,
    uploadMultiple: true,
    parallelUploads: 100,
    maxFiles: 100,
    maxFilesize: 9.53674, //MiB for 10MB
    acceptedFiles: 'image/jpeg,image/png,application/pdf,.doc,.docx',
    addRemoveLinks: true,
    previewsContainer: document.querySelector(
      '#rf-' + random_id + ' .previewsContainer'
    ),
    /*Translations*/
    dictFileTooBig:
      'Het bestand is te groot. Maximale bestandsgrootte is 10MB.',
    dictRemoveFile: 'Bestand verwijderen',
    dictInvalidFileType: 'Dit bestandstype is niet toegestaan.',

    // The setting up of the dropzone
    init: function () {
      var myDropzone = this

      // First change the button to actually tell Dropzone to process the queue.
      document
        .querySelector('#rf-' + random_id)
        .addEventListener('submit', function (e) {
          e.preventDefault()
          if (myDropzone.files.length) {
            /* dropzone will submit the whole form if it contains at least one file*/
            e.stopPropagation()
            myDropzone.processQueue()
          } else {
            /* if we have no file, the normal ajax submission is done */
            var formData = new FormData(this)

            var thank_you = this.parentNode.querySelector('.thank_you')
            var request = new XMLHttpRequest()
            window.addReadyStateChangeListener(request, this, thank_you)

            request.open('POST', this.action, true)
            request.setRequestHeader(
              'X-Requested-With',
              'XMLHttpRequest'
            ) /*tell django this is ajax*/
            request.send(formData)
          }
        })

      // Listen to the sendingmultiple event. In this case, it's the sendingmultiple event instead
      // of the sending event because uploadMultiple is set to true.
      this.on('sendingmultiple', function () {
        // Gets triggered when the form is actually being sent.
      })

      this.on('successmultiple', function (files, response) {
        // Gets triggered when the files have successfully been sent (the rest of the form might still be invalid).
        var form = this.element
        var thank_you = document.querySelector(
          '#rf-' + random_id + ' + .thank_you'
        )
        if (response.status === 400) {
          /* form is invalid */
          var errors = response.errors
          var old_errors = form.querySelectorAll('.form__error')
          if (old_errors.length) {
            old_errors.forEach(function (item) {
              item.parentNode.removeChild(item)
            })
          }
          for (var key in errors) {
            if (errors.hasOwnProperty(key)) {
              var field_errors = errors[key]
              for (var i = 0; i < field_errors.length; i++) {
                var error_msg = document.createElement('P')
                error_msg.className = 'form__error'
                error_msg.innerText = field_errors[i]

                form
                  .querySelector('.form__field--' + key)
                  .appendChild(error_msg)
              }
            }
          }
          for (var i = 0; i < this.files.length; i++) {
            /* queue again */
            this.files[i].status = Dropzone.QUEUED
            this.files[i].previewElement.classList.remove(
              'dz-complete',
              'dz-processing',
              'dz-success'
            )
          }
        } else if (response.status === 200) {
          /* form is valid, thank you */
          // scroll to thank you message
          var menu_height = document.querySelector('.block-header').offsetHeight
          var toPos =
            form.parentNode.parentNode.parentNode.parentNode.getBoundingClientRect()
              .top - menu_height
          var curScroll =
            document.documentElement.scrollTop || document.body.scrollTop
          var to = curScroll + toPos
          scrollTo(document.documentElement, to, 500)
          scrollTo(document.body, to, 500)
          setTimeout(function () {
            form.classList.add('hide')
            thank_you.classList.remove('hide')
          }, 500)
        }
      })
      this.on('errormultiple', function (files, response) {
        // Gets triggered when there was an error sending the files.
        // Maybe show form again, and notify user of error

        var form = this.element
        var errors = response.errors
        var old_errors = form.querySelectorAll('.form__error')
        if (old_errors.length) {
          old_errors.forEach(function (item) {
            item.parentNode.removeChild(item)
          })
        }
        for (var key in errors) {
          if (errors.hasOwnProperty(key)) {
            var field_errors = errors[key]
            for (var i = 0; i < field_errors.length; i++) {
              var error_msg = document.createElement('P')
              error_msg.className = 'form__error'
              error_msg.innerText = field_errors[i]

              form.querySelector('.form__field--' + key).appendChild(error_msg)
            }
          }
        }
      })
    },
  })
}
